import TextField from 'ageas-react-component-textfield'
import moment from 'moment'

import { useFillDataForSimulationStore } from '../../../Stores/useFillDataForSimulationStore'
import { useResumeStore } from '../../../Stores/useResumeStore'
import { AnimalsSecured } from '../../../Types/AnimalStore'
import { t } from '../../../i18n'
import { RiskDataContainer } from '../styles'

export const RiskData = ({ data }: { data: AnimalsSecured }) => {
  const { isResume } = useResumeStore()
  const { fillDataForSimulationRequest } = useFillDataForSimulationStore()

  const getGender = (genderId: string) =>
    (
      fillDataForSimulationRequest?.petDetailsResponse?.petGenderList || []
    )?.find((gender) => gender.code === genderId)

  return (
    <RiskDataContainer>
      <div className="row">
        <div className="col">
          <TextField
            readOnly
            label={t('pages.step5.riskData.name')}
            value={data.name}
          />
          <TextField
            readOnly
            label={t('pages.step5.riskData.species')}
            value={data.species}
          />
          <TextField
            readOnly
            label={t('pages.step5.riskData.gender')}
            value={getGender(data?.gender || '')?.shortDescription || ''}
          />
          <TextField
            readOnly
            label={t('pages.step5.riskData.licenseNumber')}
            value={data.licenseNumber}
          />
        </div>
        <div className="col">
          <TextField
            readOnly
            label={t('pages.step5.riskData.birthDate')}
            value={moment(data.birthDate).format('DD-MM-YYYY')}
          />
          <TextField
            readOnly
            label={t('pages.step5.riskData.breed')}
            value={data.breed}
          />
          <TextField
            readOnly
            label={t('pages.step5.riskData.chipNumber')}
            value={data.chipNumber}
          />
        </div>
      </div>
    </RiskDataContainer>
  )
}
